export enum eVasRuleState {
    'Creada' = 1,
    'En Proceso' = 2,
    'Pendiente Asignación' = 3,
    'Completada' = 4,
    'Con Error' = 5,
}